import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import styles from './styles/styles.css';
import type { TTimeChips } from './models';

export const TimeChips: FC<TTimeChips> = ({
    Text,
    active,
    className,
    disabled,
    onClick,
    timeSlot,
}) => (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
        className={cn(
            styles.external,
            styles.tabRoot,
            styles.tabTime,
            {
                [styles.tabTimeCommon]: !disabled && !active,
                [styles.tabTimeActive]: active && !disabled,
                [styles.tabTimeDisabled]: disabled,
            },
            className
        )}
        onClick={disabled ? undefined : onClick}
    >
        <Text styler={{ margin: 0 }} theme={active ? 'dark' : 'light'} view="primary-small">
            {timeSlot}
        </Text>
    </div>
);
